import { EmailVerifContext } from "./context";
import React from "react";
export function useEmailValidationHook() {
  return React.useContext(EmailVerifContext);
}
